module.exports = __webpack_public_path__ + "static/img/icon h tpys 1.de72c887.svg";